export const PATH = {
    HOME:'/procedure/meeting-room',
    CREATE:'/procedure/meeting-room/create/:id'
}